<script lang="ts" setup>
import imgPanicOkaneko from './1_okaneko_panic1.svg';
import imgSavingOkaneko from './2_okaneko_saving.svg';
import imgCoolOkaneko from './3_okaneko_cool.svg';
import imgThinkngOkaneko from './4_okaneko_thinking.svg';
import imgGutsOkaneko from './5_okaneko_guts.svg';
import imgOkanekoPc1OKaneko from './6_okaneko_pc1.svg';
import IconArrowIosDown from 'theme/assets/icons/fill/arrow-ios-down.svg?component';
import IconArrowIosUp from 'theme/assets/icons/fill/arrow-ios-up.svg?component';

const images = [
  imgPanicOkaneko,
  imgSavingOkaneko,
  imgCoolOkaneko,
  imgThinkngOkaneko,
  imgGutsOkaneko,
  imgOkanekoPc1OKaneko,
];

export type Card = {
  title: string;
  contentComponent: Component;
};

const props = defineProps<{
  title: string;
  imageNumber: number;
}>();

const imageUrl = images[props.imageNumber % images.length];

const isOpen = ref(false);

const onClick = () => (isOpen.value = !isOpen.value);
</script>

<template>
  <div :class="$style.container">
    <div :class="[$style.container__title, $style.title]" @click="onClick">
      <div :class="[$style.title__image, $style.image]">
        <img :src="imageUrl" alt="" loading="lazy" />
      </div>
      <h2 :class="[$style.title__titleText, $style.titleText]">
        {{ title }}
      </h2>
      <div v-if="!isOpen" :class="[$style.title__seeNext, $style.seeNext]">
        <span :class="$style.seeNext__text">続きを見る</span
        ><IconArrowIosDown
          :class="[$style.seeNext__IconArrowIos, $style.IconArrowIos]"
        />
      </div>
      <div v-else :class="[$style.title__seeNext, $style.seeNext]">
        <span :class="$style.seeNext__text">閉じる</span>
        <IconArrowIosUp
          :class="[$style.seeNext__IconArrowIos, $style.IconArrowIos]"
        />
      </div>
    </div>
    <div v-show="isOpen" :class="[$style.container__content, $style.content]">
      <slot />
    </div>
  </div>
</template>

<style lang="scss" module>
@use '../_constants.scss' as *;

.container {
  padding: 32px;
  border: 3px solid $color-border-accent-primary;
  border-radius: 16px;
}

.title {
  display: flex;
  align-items: center;
  gap: 10px;

  &__image {
    flex-shrink: 0;
  }

  &__titleText {
    width: 100%;
    font-size: 28px;
    font-weight: bold;
    line-height: 50.4px;
    color: $color-text-and-object-accent-primary;

    @include mobile-only {
      font-size: 20px;
      line-height: 36px;
    }
  }

  &__seeNext {
    flex-shrink: 0;
  }
}

.image {
  height: 80px;
  width: 80px;
}

//
.content {
  font-size: 16px;
  margin-top: 16px;

  p {
    margin-bottom: 1em;
    line-height: 1.8;
  }

  a {
    text-decoration: underline;
  }

  h3 {
    font-size: 24px;
    line-height: 43.2px;
    margin-top: 1.5em;
  }
  h4 {
    font-size: 18px;
    margin-top: 0.25em;
    margin-bottom: 0.5em;
  }
  img {
    width: 100%;
    max-width: $article-image-max-width;
    margin: 16px auto;
    display: block;
    cursor: pointer;
  }
}

.seeNext {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 16px;
  font-weight: bold;
  line-height: 28.8px;
  color: $color-text-and-object-accent-primary;
  cursor: pointer;

  &__text {
    @include mobile-only {
      display: none;
    }
  }

  &__IconArrowIos {
    fill: $color-text-and-object-accent-primary;
  }
}
</style>
